import { render, staticRenderFns } from "./SecondaryMenuItem.vue?vue&type=template&id=4e1ca5d6&scoped=true"
import script from "./SecondaryMenuItem.vue?vue&type=script&lang=js"
export * from "./SecondaryMenuItem.vue?vue&type=script&lang=js"
import style0 from "./SecondaryMenuItem.vue?vue&type=style&index=0&id=4e1ca5d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1ca5d6",
  null
  
)

export default component.exports